
define('text!templates/modules/dashboard/goal/goal.html',[],function () { return '<div class="goal-content"></div>\n';});

